<template>
    <v-app-bar flat color="white" :height="hasSubtitle ? '95' : '72'" fixed app>
        <div :class="['d-flex flex-grow-1 align-center', !backBtn.visible && $route.name == 'my-qr' ? 'px-8' : 'px-5']">
            <!-- Start Left Top Header -->
            <div class="d-flex align-start">
                <router-link v-if="backBtn.visible" :to="navigation('back')" style="text-decoration: none; color: inherit"><v-icon left x-large class="pr-4"> mdi-arrow-left </v-icon></router-link>

                <div class="header-title">
                    <div class="d-flex align-center">
                        <h2>
                            <slot name="title">Add Merchant</slot>
                        </h2>
                        <slot name="status"></slot>
                    </div>
                    <slot name="subtitle"></slot>
                </div>
            </div>
            <!-- End Left Top Header -->

            <!-- Start Right Top Header -->
            <v-card flat class="ml-auto" v-if="actionBtns.visible">
                <slot name="actionBtns">
                    <v-btn class="mx-1" :to="navigation('cancel')" :disabled="isLoading" outlined text exact>Cancel</v-btn>
                    <v-btn color="primary" class="mx-1" @click="$emit('save')" :loading="isLoading">Save</v-btn>
                </slot>
            </v-card>
            <!-- End Right Top Header -->
        </div>

        <!-- Start Header Tabs -->
        <template v-slot:extension v-if="navTab">
            <slot name="navigationTabs">
                <v-tabs class="tabs ml-8" :v-model="activeTab">
                    <v-tab :to="navigation('to', ['add'])" class="no-text-transform">Add Manually</v-tab>
                    <v-tab v-if="isPermitted(userInfo.permissions, 'import_file_uploads-index')" :to="navigation('to', ['import'])" class="no-text-transform">Import from a File (Batch Upload)</v-tab>
                </v-tabs>
            </slot>
        </template>
        <!-- End Header Tabs -->
    </v-app-bar>
</template>

<script>
export default {
    name: 'AppBar',
    props: {
        isLoading: {
            type: Boolean,
            default: false
        },
        backBtn: {
            type: Object,
            default: () => {
                return {
                    visible: true,
                    backTo: '/merchants'
                };
            }
        },
        actionBtns: {
            type: Object,
            default: () => {
                return {
                    visible: true
                };
            }
        },
        navTab: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        activeTab() {
            return this.$route.name;
        },
        hasSubtitle() {
            return !!this.$slots['subtitle'] || !!this.$scopedSlots['subtitle'];
        }
    }
};
</script>
